<template>
  <div>
    <button type="button" style="margin-right: 5px" v-bind:class="searchClass()" v-if="searchVisible" :disabled="searchDisabled" @click="emitSearchClickEvent">
      {{ searchText }}
    </button>
    <button type="button" style="margin-right: 5px" v-bind:class="clearClass()" v-if="clearVisible" :disabled="clearDisabled" @click="emitClearClickEvent">
      {{ clearText }}
    </button>
  </div>
</template>
<script>
  // WrsSearchButtons.vue
  export default {
    props: {
      searchText: {
        type: String,
        default: "Search"
      },
      searchVisible: {
        type: Boolean,
        default: true
      },
      searchDisabled: {
        type: Boolean,
        default: false
      },
      searchButtonType: {
        type: String,
        default: 'P'
      },

      clearText: {
        type: String,
        default: "Clear"
      },
      clearVisible: {
        type: Boolean,
        default: true
      },
      clearDisabled: {
        type: Boolean,
        default: false
      },
      clearButtonType: {
        type: String,
        default: 'B'
      },
    },
    methods: {
      searchClass: function () {
        return this.getClass(this.searchButtonType);
      },
      clearClass: function () {
        return this.getClass(this.clearButtonType);
      },

      getClass: function (bt) {
        var res = "btn btn-default searchButton";
        if (bt == "P") {
          res = "btn btn-primary searchButton";
        }

        return res;
      },

      emitClearClickEvent: function () {
        this.$emit('clearclicked');
      },
      emitSearchClickEvent: function () {
        this.$emit('searchclicked');
      },
    }
  }
</script>
